(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    function initAnnouncementBar(bar) {
      if (!bar || bar.dataset.ready) return;
      bar.dataset.ready = 'true';

      const msgs = Array.from(bar.querySelectorAll('.announcement-bar__msg'));
      if (msgs.length < 2) return;

      const interval = parseInt(bar.dataset.interval, 10) || 4000;
      let index = 0;
      let timer = null;

      function show(next) {
        const current = msgs[index];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        current.setAttribute('aria-hidden', 'true');
        setTimeout(() => current.classList.remove('is-leaving'), 450);

        index = next;
        msgs[index].classList.add('is-active');
        msgs[index].removeAttribute('aria-hidden');
      }

      function start() {
        stop();
        timer = setInterval(() => show((index + 1) % msgs.length), interval);
      }
      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
      start();
    }

    document.querySelectorAll('.announcement-bar').forEach(initAnnouncementBar);
    document.addEventListener('shopify:section:load', e => {
      initAnnouncementBar(e.target.querySelector('.announcement-bar'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
